import {
  Box,
  Button,
  Checkbox,
  Fade,
  MenuItem,
  Paper,
  Popper,
  PopperPlacementType,
  Select,
  TextField,
} from "@mui/material";
// import axios from "axios";
import React, { useEffect, useState, useCallback } from "react";
import api from "../../../API";
import { useSelector } from "react-redux";
import _debounce from 'lodash/debounce';
import { DetailTrans } from "../prc/TzaDetailDialog";
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import { SwWikiType } from "./TzaWikiListPage";
import { SearchBackDrop } from "../../component/common/SearchBackDrop";


const initailSwWikiData: SwWikiType = {
  idx: -1,
  site_name: "",
  title_sw: "",
  text_sw: "",
  
  title_ko: "",
  text_ko: "",
  
  use_yn: "",
  isp1_yn: "",
  isp1_user: "",
  isp1_date: "",
};

const TzaWikiDialog = (props: any) => {

  const [prc_data, setPrc_data] = useState<SwWikiType>(initailSwWikiData);

  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [open_pop, setOpen_pop] = useState(false);
  const [placement, setPlacement] = useState<PopperPlacementType>();

  const handleClick =
    (newPlacement: PopperPlacementType) =>
    (event: React.MouseEvent<HTMLButtonElement>) => {
      setAnchorEl(event.currentTarget);
      setOpen_pop((prev) => placement !== newPlacement || !prev);
      setPlacement(newPlacement);
    };

  // const [l_select, setL_select] = useState("SW")

  // const [r_select, setR_select] = useState("KO")

  const [auths, setAuths] = useState([]);
  
  const auth = useSelector((state:any)=> state.userInfo.data)
  const email = auth.user.email;

  let union_role = auth.user.roles.some((obj:any) => ['TZA_ISP'].includes(obj.role) && ['Y'].includes(obj.type));

  const getAuths = async () => {
    var result = await api.get("/getAuths");
    setAuths(result.data.data);
  };

  const [backdrop, setBackdrop] = useState<boolean>(false)

  // const getPrcDetail = async (idx: number) => {
  //   var result = await api.get("/sw-prc-detail",{params:{email:email,idx:idx}});
  //   setPrc_data(result.data.datas[0])
  // };

  const saveIsp1Data = async (isp1_yn:string) => {

    const formData = new FormData();

    formData.append("email", email);

    formData.append("isp1_yn", isp1_yn);

    // formData.append("idx", prc_data.idx.toString());

    formData.append("idx", prc_data.idx.toString())

    setBackdrop(true)

    // console.log('email', email)
    // console.log('idx', prc_data.idx.toString())
    // console.log('isp1_yn', isp1_yn)

    let massage = ""

    if(isp1_yn == 'Y'){massage = "적합 "}
    if(isp1_yn == 'N'){massage = "부적합 "}

    await api.post("/sw-wiki-update",formData)
    .then((res:any) => { alert(massage + "업데이트가 완료되었습니다."); setBackdrop(false); props.updateAfter(); })
    .catch((error:any) => {alert('오류 - '+ error.response.data.error); setBackdrop(false);})

  }

  

  // useEffect(() => {
  //   // attach the event listener
  //   document.addEventListener('keydown', handleKeyPress);

  //   // remove the event listener
  //   return () => {
  //     document.removeEventListener('keydown', handleKeyPress);
  //   };
  // }, [handleKeyPress]);

  const handleKeyPress = useCallback((event:any) => {
    // console.log(`Key pressed: ${event.key}`);
    // console.log('idx ?? ' , prc_data.idx)
    if (event.key === "1") {
      saveIsp1Data('Y')
      // 원하는 동작을 추가
    }
    if (event.key === "2") {
      saveIsp1Data('N')
      // 원하는 동작을 추가
    }
  }, [prc_data]);

  useEffect(() => {
    getAuths();
    // setData(initailData);
    // setData(props.rowDetail);
    // console.log('페이지 값',props.rowDetail)
    if(props.rowDetail != undefined){
      // console.log('props.rowDetail',props.rowDetail)
      // getPrcDetail(props.rowDetail.idx)
      if(props.rowDetail.idx != -1){
        setPrc_data(props.rowDetail)
      }
      else{
        setPrc_data(initailSwWikiData)
      }
      // getCatDetail(props.rowDetail.crw_idx)
      // getCrwDetail(props.rowDetail.crw_idx)
      // getTrsDetail(props.rowDetail.crw_idx)
    }

    // attach the event listener
    document.addEventListener('keydown', handleKeyPress);

    // remove the event listener
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };

  }, [props.rowDetail, handleKeyPress]);

  

  if(prc_data == undefined) {return <Paper sx={{width:"100%", overflow: "auto"}}><Box sx={{fontWeight:700, fontSize: "52px"}}>Loading ...</Box></Paper>}

  return (

    <Paper sx={{width:"100%", overflow: "auto"}}>
      {backdrop && ( <SearchBackDrop/> )}
      <Box sx={{margin:"1px 20px 0px 20px", fontWeight:700, fontSize: "24px", letterSpacing:"-2px"}}>데이터 정보(위키)</Box>
      <hr style={{borderTop : "2px solid #3e36a5", marginTop:"0px"}}></hr>
      <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>idx : {prc_data.idx}</Box>
      <Box display="flex">

          <Box display="flex">
            <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#c7ffbb"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>SW</Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_sw} spellCheck="false" style={{width:"664px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_sw} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
          </Box>

          <Box>
              <Paper sx={{padding:"4px", margin:"4px 2px 16px 16px", border:"3px solid #3e36a5", background: "#acdffc"}}>
                <Box sx={{width:"680px",margin:"4px",borderBottom:"2px solid #3e36a5"}}>
                  <Box sx={{display:"flex", alignItems:"center"}}>
                    <Box sx={{display:"flex", alignItems:"center"}}>
                      <Box sx={{marginLeft:"4px"}}>
                        <Box sx={{fontSize:"34px", fontWeight:700, textAlign:"center", margin:"2px"}}>KO</Box>
                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>텍스트 제목 (TITLE)</Box>
                        <Box><textarea readOnly value={prc_data.title_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"32px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                        <Box sx={{margin:"2px 0px 0px 2px", fontWeight:700}}>본문 내용 (TEXT)</Box>
                        <Box><textarea readOnly value={prc_data.text_ko || ""} spellCheck="false" style={{width:"664px",minHeight:"460px", fontSize:"15px", fontWeight:600,padding:"2px",fontFamily: "Noto Sans KR"}}  /></Box>

                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Paper>
            </Box>
            


            <Box>
              <Box sx={{width:"100%",marginTop:"20px"}}>
                <Box display="flex" justifyContent="center">
                  <Button variant="contained" sx={{fontSize:"24px", fontWeight:700, margin:"4px 8px",width:"180px",height:"80px"}}
                    onClick={() => {
                      saveIsp1Data('Y');
                    }}
                  >
                    적합 (1)
                  </Button>
                </Box>

                <Box display="flex" justifyContent="center">
                  <Button variant="contained" color="secondary" sx={{fontSize:"24px", fontWeight:700, margin:"4px 8px",width:"180px",height:"80px"}}
                    onClick={() => {
                      saveIsp1Data('N');
                    }}
                  >
                    부적합 (2)
                  </Button>
                </Box>
                
              </Box>
            </Box>
        </Box>

        

    </Paper>
  );
};

export default TzaWikiDialog;
